import { ShipmentType } from "../enums";

export class ShipmentFilterOption {
    searchKey: string;
    ShipmentStartDate: Date
    ShipmentEndDate: Date
    ShipmentCode: string
    ExportReport: boolean
    CountryId: boolean
    ReportHeader: string[] = []
    ShipmentType: ShipmentType
    HoldStartDate:Date
    HoldEndDate:Date
}
